/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import _ from 'lodash'
import { Radio, Button, Form } from 'semantic-ui-react'

import TitleField from '../fields/titleField'
import DescriptionField from '../fields/descriptionField'
import SelectDriverField from '../fields/selectDriver'
import SelectDriverSegmentField from '../fields/selectDriverSegment'

export default class NotificationForm extends React.PureComponent {
  shouldDisabled = () => {
    const { driverType, selectedDrivers, title, description } = this.props

    let valid = false

    if (title.trim().length === 0) {
      valid = true
    } else if (description.trim().length === 0) {
      valid = true
    } else if (driverType === 'custom' && _.size(selectedDrivers) === 0) {
      valid = true
    }

    return valid
  }

  onSave = e => {
    const { sendNow } = this.props
    e.preventDefault()

    sendNow()
  }

  render() {
    const {
      onFieldChange,
      onSelectDriver,
      selectedDrivers,
      driverType,
      loading,
      title,
      description,
      drivers,
      selectedDriverSegment,
      onSelectDriverSegment,
      driverSegments
    } = this.props

    return (
      <Form
        onSubmit={this.onSave}
        ref={ref => {
          this.formRef = ref
        }}
        disabled={loading}
      >
        <Form.Group widths="equal">
          <TitleField onChange={onFieldChange} value={title} />
        </Form.Group>
        <Form.Group widths="equal">
          <DescriptionField onChange={onFieldChange} value={description} />
        </Form.Group>
        <Form.Group>
          <Form.Field>
            <label>Send To</label>
            <Radio
              label="All Driver"
              name="radioGroup"
              value="all"
              checked={driverType === 'all'}
              onChange={() => onFieldChange('driverType', 'all')}
              style={{ marginRight: 10 }}
            />
            <Radio
              label="Offline Driver"
              name="radioGroup"
              value="offline"
              checked={driverType === 'offline'}
              onChange={() => onFieldChange('driverType', 'offline')}
              style={{ marginRight: 10 }}
            />
            <Radio
              label="Selected Driver"
              name="radioGroup"
              value="custom"
              checked={driverType === 'custom'}
              onChange={() => onFieldChange('driverType', 'custom')}
              style={{ marginRight: 10 }}
            />
            <Radio
              label="Selected Driver Segment"
              name="radioGroup"
              value="custom"
              checked={driverType === 'driverSegment'}
              onChange={() => onFieldChange('driverType', 'driverSegment')}
            />
          </Form.Field>
        </Form.Group>
        {driverType === 'custom' && (
          <SelectDriverField
            selectedDrivers={selectedDrivers}
            onSelectDriver={onSelectDriver}
            drivers={drivers}
          />
        )}
        {
          driverType === 'driverSegment' && (
            <SelectDriverSegmentField
              selectedDriverSegment={selectedDriverSegment}
              onSelectDriverSegment={onSelectDriverSegment}
              driverSegments={driverSegments}
              drivers={drivers}
            />
          )
        }
        <Button disabled={this.shouldDisabled() || loading} loading={loading} type="submit">
          Send Now
        </Button>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/drivers/forms/notificationForm.js